import { render, staticRenderFns } from "./MVMImage.vue?vue&type=template&id=41c1ddea&"
import script from "./MVMImage.vue?vue&type=script&lang=js&"
export * from "./MVMImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports